<template>
  <span :class="['order-pick-type', `order-pick-type-${item.id}`]">{{ item.name }}</span>
</template>

<script>
export default {
  name: "PickType",
  props: {
    item: {
      type: [String, Object],
      required: true,
    },
  },

  methods: {},
  created() {},
};
</script>

<style lang="scss" scoped>
.order-pick-type {
  display: inline-block;
  padding: 5.5px 1rem;
  border-radius: 15px;
  line-height: 14px;
}
</style>
